import React, { ReactElement } from "react";
import { Link } from "react-router-dom";
import styles from "./index.module.css";

export const PageHeader: React.FC<{ parentURL?: string }> = (props) => {
	const { parentURL } = props;

	const inner: ReactElement =
		parentURL === undefined ? (
			<>{props.children}</>
		) : (
			<Link className={styles.pageHeaderLink} to={parentURL}>
				{props.children}
			</Link>
		);

	return (
		<div className={styles.pageHeader}>
			<h1>{inner}</h1>
		</div>
	);
};
